import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, inject, Injectable, Injector } from '@angular/core';

import { PlatformConfigService } from '../config/config.service';
import { MonitoringService } from './monitoring.service';

@Injectable()
export class MonitoringErrorHandler implements ErrorHandler {
  #injector = inject(Injector);
  get #monitoringService() {
    return this.#injector.get(MonitoringService);
  }
  get #configService() {
    return this.#injector.get(PlatformConfigService);
  }
  get #debugEnabled() {
    return this.#configService.getEnv('DEBUG_MONITORING');
  }

  handleError(error: Error | HttpErrorResponse): void {
    let context = 'application';
    let metadata: Record<string, string | number | boolean> = {};

    if (error instanceof HttpErrorResponse) {
      context = 'http';
      metadata = {
        'http.status_code': error.status,
        'http.url': error.url || 'unknown',
        'http.statusText': error.statusText,
      };

      if (error.error) {
        try {
          if (typeof error.error === 'string') {
            metadata['http.response'] = error.error.substring(0, 200);
          } else {
            metadata['http.response'] = JSON.stringify(error.error).substring(0, 200);
          }
        } catch {
          // Ignore serialization errors
        }
      }
    } else {
      try {
        const stack = error.stack || '';
        const componentMatch = stack.match(/at\s+(\w+Component)\./);
        if (componentMatch && componentMatch[1]) {
          metadata['component.name'] = componentMatch[1];
        }
      } catch {
        // Ignore parsing errors
      }
    }

    this.#monitoringService.trackError(error, context, metadata);

    if (this.#debugEnabled) {
      console.error('Unhandled error:', error);
    }
  }
}
